"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _hooks = require("../../hooks");

var _utils = require("../../utils");

var _TableContainer = _interopRequireDefault(require("./TableContainer"));

var _helperComponents = require("./helperComponents");

var _core = require("@emotion/core");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var ScrollWrapper = function ScrollWrapper(_ref) {
  var maxWidth = _ref.maxWidth,
      children = _ref.children,
      hasStickyHeader = _ref.hasStickyHeader,
      maxHeight = _ref.maxHeight,
      shouldScrollHorizontally = _ref.shouldScrollHorizontally,
      ariaLabelledby = _ref.ariaLabelledby,
      hasInteractiveElement = _ref.hasInteractiveElement;

  // Be used to indicate if table is focused by tab press.
  // This solution can be removed once Safari starts supporting :focus-visible.
  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      isFocusedByTab = _useState2[0],
      setIsFocusedByTab = _useState2[1];

  var _useResizeObserver = (0, _hooks.useResizeObserver)(),
      scrollWrapperRef = _useResizeObserver.ref;

  var checkIfHasScrollbar = function checkIfHasScrollbar() {
    var element = scrollWrapperRef.current;

    if (!element) {
      return false;
    }

    var isScrollableVertically = element.scrollHeight > element.clientHeight;
    var isScrollableHorizontally = element.scrollWidth > element.clientWidth;
    return isScrollableVertically || isScrollableHorizontally;
  };

  var handleKeyUp = function handleKeyUp(e) {
    if (e.key === _utils.EventKeys.TAB && isFocusedByTab !== true && (0, _utils.getActiveElement)() === scrollWrapperRef.current) {
      setIsFocusedByTab(true);
    }
  };

  var handleBlur = function handleBlur() {
    if (isFocusedByTab === true) {
      setIsFocusedByTab(false);
    }
  };

  var commonProps = {
    onKeyUp: handleKeyUp,
    onBlur: handleBlur,
    isFocusedByTab: isFocusedByTab,
    hasStickyHeader: hasStickyHeader,
    maxHeight: maxHeight,
    ref: scrollWrapperRef
  };
  var hasScrollBar = checkIfHasScrollbar();

  if (shouldScrollHorizontally) {
    return (0, _core.jsx)(_helperComponents.TableContainerHorizontal // Helps to understand if table is focused only by tab press.
    , (0, _extends2.default)({}, commonProps, {
      hasScrollBar: hasScrollBar,
      maxWidth: maxWidth,
      tabIndex: hasScrollBar && !hasInteractiveElement ? 0 : undefined,
      role: hasScrollBar && !hasInteractiveElement ? 'region' : undefined,
      "aria-labelledby": hasScrollBar && !hasInteractiveElement ? ariaLabelledby : undefined
    }), children);
  }

  return (0, _core.jsx)(_TableContainer.default, (0, _extends2.default)({}, commonProps, {
    hasScrollBar: hasScrollBar,
    tabIndex: hasScrollBar && !hasInteractiveElement ? 0 : undefined,
    role: hasScrollBar && !hasInteractiveElement ? 'region' : undefined,
    "aria-labelledby": hasScrollBar && !hasInteractiveElement ? ariaLabelledby : undefined
  }), children);
};

ScrollWrapper.displayName = 'ScrollWrapper';
var _default = ScrollWrapper;
exports.default = _default;